// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_34-3";
export var dialog = "_34-0";
export var divClassnameSwatch = "_34-8";
export var flexSwatch = "_34-4";
export var header = "_34-1";
export var styleAttributeSwatch = "_34-7";
export var swatch = "_34-2";
export var textHeaderSwatch = "_34-5";
export var webSwatch = "_34-6";